import Template from './Template'
import api from '../../api'
import Webview from '../component/native/visible/Webview'
import PlayerView from '../component/native/visible/PlayerView'


class VideoTemplate extends Template{
    constructor(arg = {
        campaign: {},
        unit: {}
    }) {
        super(arg)

        this.campaign = arg.campaign || {}
        this.unit = arg.unit || {}

        this.webview = undefined
        this.playerView = undefined
    }

    async init(campaign, dataSource) {
        super.init()

        // 加载制定campaign
        if (campaign && dataSource) {
            this.setDatas(campaign, dataSource)
        } else {//自动获取campaign
            try {
                const res = await this.fetchInfo()
                console.log({res})
                const {code, data = {}} = res
                if (code === 0) {
                    const {campaignList} = data
                    const campaign = campaignList[0]
                    this.setDatas(campaign, data)
                } else {
                    throw new Errow('初始化数据失败')
                }
            } catch (e) {
                console.warn('初始化数据失败, 请确认当前环境为 mintegral SDK')
            }
        }
        this.initComponents()
    }

    setDatas(campaign, dataSource) {
        const {unitSetting} = dataSource
        this.campaignId = campaign.id
        this.unitSetting = unitSetting
        this.unitId = unitSetting.unitId
        this.dataSource = dataSource
    }

    initComponents() {
        this.webview = Webview.getInstance()
        this.playerView = PlayerView.getInstance()
        this.webview.append(this.playerView)
    }

}

export default VideoTemplate